module.exports = __webpack_public_path__ + "static/media/cross-primary-ios.5a2c88c1.svg";